import React, {useState, useEffect} from 'react';

function FeedbackPage({navigateContact, handleComplete}) {

    const [seconds, setSeconds] = useState(10);
  
    useEffect(() => {
      if (seconds === 0) handleComplete();
  
      const timer = setInterval(() => {
        setSeconds(prev => prev - 1);
      }, 1000);
  
      return () => clearInterval(timer);
    }, [seconds]);

    const handleButtonClick = (e) => {
      e.stopPropagation();
      navigateContact();
    }
  
  return (
    <div className='w-screen h-screen bg-[#f9ece2] justify-items-center content-center font-bold text-[#223641]' onClick={()=>handleComplete()}>
      <img className='w-2/5 max-w-lg' src={process.env.PUBLIC_URL + '/logo.png'} alt='logo'/>
        <h1 className='text-5xl my-8'>Thank you for the feedback</h1>
        {navigateContact && <button 
          className='flex flex-col my-5 border-[#223641] rounded-xl border-2 px-10'
          onClick={handleButtonClick}>
          <span className='text-3xl'>CLICK ME</span><span className=' tracking-wider'>IF WANT TO BE CONTACTED</span>
        </button>}
        {!navigateContact && <img className='w-1/4 my-10' src={process.env.PUBLIC_URL + '/heart.png'} alt='heart-icon'/>}
        <h2 className='text-2xl font-normal'>We're so glad that you chose our clinic <br/> for your medical needs.</h2>
        <h3 className='mt-2 font-normal'>Returning back to homepage in... {seconds}</h3>
    </div>
  );
}

export default FeedbackPage;